import { useMediaQuery } from '@material-ui/core';
import { ContactPersonsOption } from '../interfaces/contact-persons';
import { FormSchema } from '../interfaces/form-schema';
import theme from '../styles/theme';

export const formSchema = (
  contactPersons: ContactPersonsOption[] = [],
  gdpr = false
): FormSchema[] => {
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  return [
    {
      type: 'string',
      required: true,
      name: 'name',
      variant: 'outlined',
      fieldType: 'input',
    },
    {
      type: 'string',
      required: gdpr,
      name: 'company',
      variant: 'outlined',
      fieldType: 'input',
    },
    {
      type: 'email',
      required: true,
      name: 'email',
      variant: 'outlined',
      fieldType: 'input',
    },
    {
      type: 'tel',
      required: true,
      name: 'phone',
      variant: 'outlined',
      fieldType: 'input',
    },
    {
      type: 'string',
      required: true,
      name: 'job',
      fullWidth: true,
      variant: isMobile ? 'outlined-mobile' : 'standard',
      fieldType: 'input',
      helperText: true,
      onBlur: true,
      // andOrPair: 'offerNumber',
      // titleText: 'jobOfferRequired',
      regex: /^(25\d{5}|26\d{5}|[Tt]14\d{4}|[Tt]15\d{4}|[Tt]16\d{4})$/,
    },

    // {
    //   type: 'string',
    //   required: false,
    //   name: 'offerNumber',
    //   variant: isMobile ? 'outlined-mobile' : 'standard',
    //   fieldType: 'input',
    //   andOrPair: 'job',
    // },
    {
      type: 'string',
      required: true,
      name: 'jobName',
      fullWidth: true,
      variant: isMobile ? 'outlined-mobile' : 'standard',
      fieldType: 'input',
    },
    {
      type: 'number',
      required: false,
      name: 'addressCount',
      variant: isMobile ? 'outlined-mobile' : 'standard',
      fieldType: 'input',
      dontShow: !gdpr,
    },
    {
      type: 'number',
      required: false,
      name: 'printCount',
      variant: isMobile ? 'outlined-mobile' : 'standard',
      fieldType: 'input',
      dontShow: !gdpr,
    },
    {
      type: 'string',
      required: false,
      name: 'message',
      fullWidth: true,
      variant: isMobile ? 'outlined-mobile' : 'standard',
      fieldType: 'input',
      multiline: true,
      rows: 4,
    },
    {
      type: 'select',
      fieldType: 'autocomplete',
      required: true,
      name: 'contactPerson',
      fullWidth: true,
      variant: isMobile ? 'outlined-mobile' : 'standard',
      options: contactPersons,
      select: true,
    },
  ];
};
